import { buildPath } from '@e-socna/utils';

import {
  PATH_ORGANIZATION_ADDRESSES,
  PATH_PERSON_ADDRESSES,
} from '../app/constants/paths.constant';

import { NewTabButton } from './NewTabButton';

interface Props {
  readonly thirdParty: Readonly<{ __typename?: string; _id: string }>;
  // Who the third party is to the screen: « du destinataire du devis ».
  readonly ofLabel: string;
}

export const ThirdPartyAddressesButton = ({
  thirdParty,
  ofLabel,
}: Readonly<Props>) => (
  <NewTabButton
    href={buildPath(
      thirdParty.__typename === 'Person'
        ? PATH_PERSON_ADDRESSES
        : PATH_ORGANIZATION_ADDRESSES,
      { id: thirdParty._id },
    )}
    label={`Modifier les adresses ${ofLabel}`}
  />
);
